export default class blackoutContentservice {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/blackoutContents/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/blackoutContents', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/blackoutContents', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/blackoutContents/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/blackoutContents/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BlackoutContentService.js